import React from 'react';
import { connect } from 'react-redux';
// Game(kit) imports
import gameKit from '../../../../GameKit';
import { findLevelByUuid } from '../../../reducers/gameReducer';
// Shared imports
import settings from '../../../../settings';
import { GuidePublishState } from '../../../shared';

const maxTitleLength = 100;
const maxDescLength = 512;

class InputContainer extends React.Component {
    onChangeTitle = e => {
        let titleStr = e.target.value;

        if (titleStr && titleStr.length > maxTitleLength) {
            titleStr = titleStr.substring(0, maxTitleLength);
        }

        gameKit.updateGameSettings({
            title: titleStr
        });
    };

    onChangeDescription = e => {
        let descStr = e.target.value;

        if (descStr && descStr.length > maxDescLength) {
            descStr = descStr.substring(0, maxDescLength);
        }

        gameKit.updateGameSettings({
            description: descStr
        });
    };

    render = () => {
        const { game, gameGuide } = this.props;

        let style = {};
        let imgElement = <img src={`${settings.assetsPath}img/icons/camera.png`} alt="Thumbnail camera" />;
        // Check if game has thumbnail
        if (game.thumbnail !== undefined) {
            const i = findLevelByUuid(game.levels, game.thumbnail);
            if (i >= 0) {
                style = {
                    backgroundImage: `url(${game.levels[i].thumbnail})`
                };
                imgElement = <></>;
            }
        }

        const thumbnailError = gameGuide.publishState & GuidePublishState.THUMBNAIL ? 'error' : '';

        return (
            <div className="input-container">
                <div className={`thumbnail-container ${thumbnailError}`} style={style}>
                    {imgElement}
                </div>
                <div className="input-fields">
                    <div className="input-title">
                        <input type="text" placeholder="Titel" value={game.title} onChange={this.onChangeTitle} className={gameGuide.publishState & GuidePublishState.TITLE ? 'error' : ''} />
                        <img src={`${settings.assetsPath}img/icons/arrow-left.png`} alt="Pijl links" className="arrow-left-icon arrow-left-icon-first" />
                        <span>Geef je game een titel</span>
                    </div>
                    <div className="input-desc">
                        <textarea
                            placeholder="Omschrijving van je game"
                            onChange={this.onChangeDescription}
                            className={gameGuide.publishState & GuidePublishState.DESC ? 'error' : ''}
                            value={game.description}
                        />
                        <div className="post-input-desc">
                            <img src={`${settings.assetsPath}img/icons/arrow-left.png`} alt="Pijl links" className="arrow-left-icon" />
                            <span>
                                Wat moet de speler doen ?<br />
                                Is er iets gevaarlijks of lastig ?
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    game: state.game,
    gameGuide: state.gameGuide
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InputContainer);
